import React from "react";

import { Avatar, Card, CardHeader, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

import { makeStyles } from "@material-ui/core/styles";
import { grey } from '@material-ui/core/colors';

/**
 * Props para o componente CardCounter
 * @interface CardCounterProps
 */
interface CardCounterProps {
	/** Ícone a ser exibido no avatar — pode ser string ou React node */
	icon: string | React.ReactNode;
	/** Título do card */
	title: string;
	/** Valor principal a ser exibido */
	value: string | number;
	/** Flag de carregamento — se true, exibe skeleton */
	loading: boolean;
}

const useStyles = makeStyles(theme => ({
	cardAvatar: {
		fontSize: '55px',
		color: grey[500],
		backgroundColor: '#ffffff',
		width: theme.spacing(7),
		height: theme.spacing(7)
	},
	cardTitle: {
		fontSize: '18px',
		color: theme.palette.text.primary
	},
	cardSubtitle: {
		color: grey[600],
		fontSize: '14px'
	}
}));

/**
 * Componente CardCounter — exibe um card com contador/métrica
 * 
 * @component
 * @example
 * <CardCounter 
 *   icon="📊" 
 *   title="Total de Mensagens" 
 *   value={1234} 
 *   loading={false}
 * />
 */
const CardCounter: React.FC<CardCounterProps> = ({ icon, title, value, loading }) => {
	const classes = useStyles();
    return !loading ? 
        <Card>
            <CardHeader
                avatar={
                    <Avatar className={classes.cardAvatar}>
                        {icon}
                    </Avatar>
                }
                title={
                    <Typography variant="h6" component="h2" className={classes.cardTitle}>
                        { title }
                    </Typography>
                }
                subheader={
                    <Typography variant="subtitle1" component="p" className={classes.cardSubtitle}>
                        { value }
                    </Typography>
                }
            />
        </Card>
        : <Skeleton variant="rect" height={80} />
}

export default CardCounter;